<header class="site-header" [class.menu-open]="isMenuOpen">
  <div class="container header-inner">
    <a class="brand" href="#hero" aria-label="Retour en haut">
      <span class="brand-pseudo">{{ pseudo }}</span>
      <span class="brand-name">{{ fullName }}</span>
    </a>

    <nav class="nav-desktop" aria-label="Navigation principale">
      @for (item of navItems; track item.id) {
        <a [href]="'#' + item.id" (click)="onNavigate()">{{ item.label }}</a>
      }
    </nav>

    <div class="header-actions">
      <button
        type="button"
        class="theme-toggle"
        (click)="toggleTheme.emit()"
        [attr.aria-label]="isDark ? 'Passer en mode clair' : 'Passer en mode sombre'"
      >
        <span class="toggle-dot" aria-hidden="true"></span>
        <span class="toggle-label">{{ isDark ? 'Dark' : 'Light' }}</span>
      </button>

      <button
        type="button"
        class="menu-toggle"
        (click)="onToggleMenu()"
        [attr.aria-expanded]="isMenuOpen"
        aria-controls="mobile-nav"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </div>

  <nav class="nav-mobile" id="mobile-nav" aria-label="Navigation mobile">
    @for (item of navItems; track item.id) {
      <a [href]="'#' + item.id" (click)="onNavigate()">{{ item.label }}</a>
    }
  </nav>
</header>
